var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTravelAndLeisure = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Travel-Luggage-1--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Travel Luggage 1 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.39 17.89a4.5 4.5 0 0 0 -2.89 -8H2.58a0.23 0.23 0 0 1 -0.19 -0.09 0.26 0.26 0 0 1 -0.05 -0.22A10 10 0 0 1 12 2.19a9.88 9.88 0 0 1 4.89 1.29 0.24 0.24 0 0 1 0.12 0.28 0.25 0.25 0 0 1 -0.24 0.18h-2.52a2.75 2.75 0 0 0 0 5.5 2.57 2.57 0 0 1 1.83 0.79 0.59 0.59 0 0 0 0.17 0.1l2.25 0a4 4 0 0 1 3.88 3 0.26 0.26 0 0 0 0.17 0.18 4.24 4.24 0 0 1 1 0.46 0.25 0.25 0 0 0 0.24 0 0.24 0.24 0 0 0 0.14 -0.19 12.36 12.36 0 0 0 0.07 -1.59 12 12 0 1 0 -15.06 11.6 0.51 0.51 0 0 0 0.46 -0.11 0.5 0.5 0 0 0 0.16 -0.46 2.89 2.89 0 0 1 0 -0.88 0.49 0.49 0 0 0 -0.35 -0.55 10.05 10.05 0 0 1 -1.7 -0.68v-1.3a2.52 2.52 0 0 1 0.88 -1.92Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 17.56a2.75 2.75 0 0 0 -2.75 -2.75 0.25 0.25 0 0 1 -0.25 -0.25 2.75 2.75 0 0 0 -2.75 -2.75h-1.5A2.75 2.75 0 0 0 14 14.56a0.25 0.25 0 0 1 -0.25 0.25A2.75 2.75 0 0 0 11 17.56v3.5a2.75 2.75 0 0 0 2.75 2.75h7.5A2.75 2.75 0 0 0 24 21.06Zm-8.5 -3a1.25 1.25 0 0 1 1.25 -1.25h1.5a1.25 1.25 0 0 1 1.25 1.25 0.25 0.25 0 0 1 -0.25 0.25h-3.5a0.25 0.25 0 0 1 -0.25 -0.25Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTravelAndLeisure);
export default ForwardRef;